
import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JaldeeReportService } from 'src/app/services/jaldee-report.service';
@Component({
  selector: 'app-reimburse-dialog',
  templateUrl: './reimburse-dialog.component.html',
  styleUrls: ['./reimburse-dialog.component.css']
})
export class ReimburseDialogComponent implements OnInit {
  public reimburseForm: UntypedFormGroup;
  api_error;
  api_success;
  invoiceDetails: any;
  reimbursePaidDetails: Object;
  showPaymentRadio = false;
  btndisabled = false;
  showReimbursePay = false;
  jBankAmount: any;
  jCAmount: any;
  jCashAmount: any;
  granTotal: any;
  showdisplayNote: boolean;
  showprivateNote: boolean;
  showNoteSection: boolean;
  action: any;
  details: any;
  disableConfirmbtn = false;
  constructor(private formbuilder: UntypedFormBuilder, private jaldeeReportService: JaldeeReportService, private dialogRef: MatDialogRef<any>,private matDialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, private reportService: JaldeeReportService) { }
  ngOnInit() {
  
   
 
      this.reimburseForm = this.formbuilder.group({
        invoice: {
          invoiceId: this.data.invoiceId
        },
        displayNote: '',
        privateNote: '',
        jaldeePaymentmode: ['CASH'],
        jaldeeReimburseFor: ['TOTAL'],
        grandTotal: this.granTotal,
        jbankTotal: this.jBankAmount,
        jcTotal: this.jCAmount,
        jCashTotal: this.jCashAmount,
      });
    
    this.invoiceDetails = this.data;
    console.log(this.invoiceDetails)
    console.log('invoiceDetails............' + JSON.stringify(this.invoiceDetails));
    if (this.invoiceDetails.status === 'PAYMENTPENDING') {
     if (this.invoiceDetails.subTotalJaldeeCoupons > 0 && (this.invoiceDetails.subTotalJaldeeBank <= 0 && this.invoiceDetails.subTotalJCash <= 0)) {
      // this.showReimbursePay = true;
        this.reimburseForm.get('jaldeeReimburseFor').setValue('JC');
      } else if (this.invoiceDetails.subTotalJaldeeBank > 0  && (this.invoiceDetails.subTotalJaldeeCoupons  <= 0 && this.invoiceDetails.subTotalJCash <= 0)) {
     
        // this.showReimbursePay = true;
      this.reimburseForm.get('jaldeeReimburseFor').setValue('JBANK');
      }
      else if (this.invoiceDetails.subTotalJCash > 0  && (this.invoiceDetails.subTotalJaldeeCoupons  <= 0 && this.invoiceDetails.subTotalJaldeeBank <= 0)) {
      
        // this.showReimbursePay = true;
      this.reimburseForm.get('jaldeeReimburseFor').setValue('JCASH');
      } else if ((this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJaldeeBank > 0 )|| (this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeBank > 0)|| (this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeCoupons > 0)) {
       
        this.reimburseForm.get('jaldeeReimburseFor').setValue('TOTAL');
        // this.showReimbursePay = true;
      }
    } 
    else if (this.invoiceDetails.status === 'PARTIALLYPAID'){
      if (this.invoiceDetails.subTotalJaldeeCoupons > 0 && (this.invoiceDetails.subTotalJaldeeBank <= 0 && this.invoiceDetails.subTotalJCash <= 0)) {
        // this.showReimbursePay = true;
          this.reimburseForm.get('jaldeeReimburseFor').setValue('JC');
        } else if (this.invoiceDetails.subTotalJaldeeBank > 0  && (this.invoiceDetails.subTotalJaldeeCoupons  <= 0 && this.invoiceDetails.subTotalJCash <= 0)) {
       
          // this.showReimbursePay = true;
        this.reimburseForm.get('jaldeeReimburseFor').setValue('JBANK');
        }
        else if (this.invoiceDetails.subTotalJCash > 0  && (this.invoiceDetails.subTotalJaldeeCoupons  <= 0 && this.invoiceDetails.subTotalJaldeeBank <= 0)) {
        
          // this.showReimbursePay = true;
        this.reimburseForm.get('jaldeeReimburseFor').setValue('JCASH');
        } else if ((this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJaldeeBank > 0 )|| (this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeBank > 0)|| (this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeCoupons > 0) ||(this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeBank > 0) ) {
          // this.showReimbursePay = true;
          this.reimburseForm.get('jaldeeReimburseFor').setValue('TOTAL');
        
         
        }
    }else {
      
       if (this.invoiceDetails.jBankPaid === false && this.invoiceDetails.subTotalJaldeeBank > 0) {
       
      this.showReimbursePay = true;
      this.reimburseForm.get('jaldeeReimburseFor').setValue('JBANK');
    } else if (this.invoiceDetails.jcPaid === false && this.invoiceDetails.subTotalJaldeeCoupons > 0) {
    
      this.showReimbursePay = true;
      this.reimburseForm.get('jaldeeReimburseFor').setValue('JC');
    }else{
     
      this.showReimbursePay = true;
      this.reimburseForm.get('jaldeeReimburseFor').setValue('JCASH'); 
    }
  }
if (this.invoiceDetails.status !== 'PAYMENTPENDING') {
  this.reportService.getReimbursePaymentDetails(this.invoiceDetails.invoiceId)
  .subscribe(res => {
   this.reimbursePaidDetails = res;
   console.log(this.reimbursePaidDetails);
   console.log('reimbursePaidDEtails..' + JSON.stringify(this.reimbursePaidDetails));
  });
 }
}
  OnReimburseSubmit() {
    var jBank =this.jBankAmount;
    var jBank_amount:number = +jBank;
    var jcoupon =this.jCAmount;
    var jcoupon_amount:number = +jcoupon;
    var jCash =this.jCashAmount;
    var jcash_amount:number = +jCash;
    if(this.jBankAmount && this.jCAmount ){
     

      this.granTotal =  jBank_amount + jcoupon_amount;
      console.log(this.jBankAmount)
      console.log(this.jCAmount)
      console.log(this.granTotal)
    }
    else if(this.jBankAmount && this.jCashAmount){
      this.granTotal = jBank_amount+ jcash_amount
    }
  else if(this.jCAmount && this.jCashAmount){
    this.granTotal = jcoupon_amount + jcash_amount
  }
    this.api_error = '';
    this.btndisabled = true;
    const reimburseArray: any = [];
    const formData = this.reimburseForm.value;
    console.log('jaldee reimburse for........' + formData.jaldeeReimburseFor);
    if (this.invoiceDetails.subTotalJaldeeBank > 0 || this.invoiceDetails.subTotalJaldeeCoupons > 0 || this.invoiceDetails.subTotalJCash > 0) {
      if (formData.jaldeeReimburseFor == null) {
        this.api_error = 'Please select reimburse for';
      } else {
        console.log('jaldee reimburse for........' + formData.jaldeeReimburseFor);
        switch (formData.jaldeeReimburseFor) {
          case 'JBANK':
          
            {
              if ((this.invoiceDetails.subTotalJaldeeCoupons === 0 && this.invoiceDetails.subTotalJCash === 0) || (this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJCash > 0) || (this.invoiceDetails.subTotalJaldeeBank > 0)){
                formData.jbankTotal = this.jBankAmount;
              }
              delete formData.grandTotal;
              delete formData.jcTotal;
              delete formData.jCashTotal;
              break;
            }
          case 'JC':
           
            {
              if ((this.invoiceDetails.subTotalJaldeeBank === 0 && this.invoiceDetails.subTotalJCash === 0) || (this.invoiceDetails.subTotalJaldeeBank > 0 && this.invoiceDetails.subTotalJCash > 0) || (this.invoiceDetails.subTotalJaldeeCoupons > 0)){
               
                formData.jcTotal = this.jCAmount;
              }
              delete formData.grandTotal;
              delete formData.jbankTotal;
              delete formData.jCashTotal;
              break;
            }
          case 'JCASH':
           
                {
                  if ((this.invoiceDetails.subTotalJaldeeCoupons === 0 && this.invoiceDetails.subTotalJaldeeBank === 0) || (this.invoiceDetails.subTotalJaldeeCoupons >0 && this.invoiceDetails.subTotalJaldeeBank > 0) || (this.invoiceDetails.subTotalJCash > 0)){
                   
                    formData.jCashTotal = this.jCashAmount;
                  }
                  delete formData.grandTotal;
                  delete formData.jbankTotal;
                  delete formData.jcTotal;
                  break;
    
                }
            
          case 'TOTAL':
           
            {
              if(this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJaldeeBank > 0){
              
                formData.jbankTotal = this.jBankAmount;
                formData.jcTotal = this.jCAmount;
                formData.jCashTotal = 0;
              }
              else if(this.invoiceDetails.subTotalJaldeeBank > 0 && this.invoiceDetails.subTotalJCash > 0){
            
                formData.jbankTotal = this.jBankAmount;
                formData.jcTotal = 0;
                formData.jCashTotal = this.jCashAmount;
              }
              else if(this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJCash > 0){
               
                formData.jbankTotal = 0;
                formData.jcTotal = this.jCAmount;
                formData.jCashTotal = this.jCashAmount;
              }
              else if((this.invoiceDetails.subTotalJaldeeBank > 0 && this.invoiceDetails.subTotalJCash > 0) || (this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJCash > 0) ||(this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJCash > 0)||(this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeBank > 0)){
              
                formData.jbankTotal = this.jBankAmount;
                formData.jcTotal = this.jCAmount;
                formData.jCashTotal = this.jCashAmount;
              }
              formData.grandTotal = this.granTotal;
             

              // delete formData.jbankTotal;
              // delete formData.jcTotal;
              // delete formData.jCashTotal;
            }
        }
      }
    } else {
      if (formData.jaldeeReimburseFor == null) {
        if (this.invoiceDetails.subTotalJaldeeBank === 0) {
          formData.jcTotal = this.invoiceDetails.subTotalJaldeeCoupons;
          delete formData.jbankTotal;
          delete formData.jCashTotal;
          delete formData.grandTotal;
        } else if (this.invoiceDetails.subTotalJaldeeCoupons === 0) {
          formData.jbankTotal = this.invoiceDetails.subTotalJaldeeBank;
          delete formData.jcTotal;
          delete formData.jCashTotal;
          delete formData.grandTotal;
        } 
        else if (this.invoiceDetails.subTotalJCash === 0) {
          formData.jCashTotal = this.invoiceDetails.subTotalJCash;
          delete formData.jcTotal;
          delete formData.jbankTotal;
          delete formData.grandTotal;
        } else {
          this.api_error = 'Please select Reimburse For';
        }
      }
    }
    if (formData.jaldeePaymentmode == null) {
      this.api_error = 'Please select payment mode';
    }
    reimburseArray.push(formData);
    console.log(reimburseArray)
    this.reportService.reimburse(reimburseArray)
      .subscribe(res => {
    
        this.api_success = 'Reimbursed successfuly';
        setTimeout(() => {
          this.btndisabled = false;
          this.matDialogRef.close();
        }, 2000);
        
        setTimeout(() => {
          this.matDialogRef.close();
        }, 2000);

      },
        (error) => {
          this.btndisabled = false;
          this.api_error = error.error;
        });
  }
  showReimburse(){
   
    if(this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJaldeeBank > 0){
     
      if(this.jBankAmount !=undefined && this.jCAmount !=undefined){
        
        this.showReimbursePay = true;
      }
      else{
        this.showReimbursePay = false;
      }
      
    }
    
   else if(this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeBank > 0){
    if( this.jBankAmount !=undefined && this.jCashAmount !=undefined){
      this.showReimbursePay = true;
    }
    else{
      this.showReimbursePay = false;
    }
   }
   else if(this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeCoupons > 0){
    if(this.jCAmount !=undefined && this.jCashAmount !=undefined){
      this.showReimbursePay = true;
    }
    else{
      this.showReimbursePay = false;
    }
   }
   
   else if(this.invoiceDetails.subTotalJCash > 0 && this.invoiceDetails.subTotalJaldeeCoupons > 0 && this.invoiceDetails.subTotalJaldeeBank > 0){
    if(this.jCAmount !=undefined && this.jCashAmount !=undefined && this.jBankAmount !=undefined){
      this.showReimbursePay = true;
    }
    else{
      this.showReimbursePay = false;
    }
   }
   else if(this.invoiceDetails.subTotalJaldeeBank > 0){
    if( this.jBankAmount !=undefined){
      this.showReimbursePay = true;
    }
    else{
      this.showReimbursePay = false;
    }
   }
   else if(this.invoiceDetails.subTotalJaldeeCoupons > 0){
    if( this.jCAmount !=undefined){
      this.showReimbursePay = true;
    }
    else{
      this.showReimbursePay = false;
    }
   }
   else if(this.invoiceDetails.subTotalJCash > 0){
    if( this.jCashAmount !=undefined){
      this.showReimbursePay = true;
    }
    else{
      this.showReimbursePay = false;
    }
   }
  }
  addNote(note,type,details){
    this.details = details;
    console.log(this.details)
    this.action = type;
  
    console.log(this.action)
    if(note === 'displayNote'){
      
      this.showNoteSection = true;
      this.showdisplayNote = true;
      this.showprivateNote = false;
    }
    else if(note === 'privateNote'){
      this.showNoteSection = true;
      this.showdisplayNote = false;
      this.showprivateNote = true;
    }
    if(this.action === 'edit'){
      this.reimburseForm.patchValue({
       
        displayNote: this.details.displayNote,
        privateNote: this.details.privateNote
      });
     
    }
  }
  noteUpdate(){
    console.log()
    const data = {
      'internalNotes': this.reimburseForm.get('displayNote').value,
      'privateNotes': this.reimburseForm.get('privateNote').value

    };
    this.jaldeeReportService.noteUpdate(this.details.invoice.invoiceId,this.details.paymentId , data)
    .subscribe(res => {
      this.api_success = 'Note updated successfully';
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
        }, 2000);
    },
      (error) => {
        this.disableConfirmbtn = false;
        this.api_error = error.error;
       }
    );
  }
}